export default __webpack_public_path__ + "static/media/tab-all-blue.26036dc3.svg";